export function normalizeAuthErrorMessage(value) {
  const raw = String(value || "").trim();
  if (!raw) return "Failed to initiate login. Please try again.";
  const normalized = raw.toLowerCase();
  if (
    normalized.includes("internal server error")
    || normalized.includes("fetch failed")
    || normalized.includes("eai_again")
    || normalized.includes("getaddrinfo")
    || normalized.includes("token_exchange_failed")
    || normalized.includes("admin_token_failed")
  ) {
    return "Sign-in failed because the identity server is unreachable or misconfigured. Verify issuer/hosted domain, client credentials, callback URL, and network/DNS access.";
  }
  return raw;
}
